export const BANNER_URL = 'https://assets.nflxext.com/ffe/siteui/vlv3/7ca5b7c7-20aa-42a8-a278-f801b0d65fa1/fb548c0a-8582-43c5-9fba-cd98bf27452f/IN-en-20240326-popsignuptwoweeks-perspective_alpha_website_small.jpg';
export const PHOTO_URL = 'https://avatars.githubusercontent.com/u/56727751?v=4';
export const AVATAR_URL = 'https://occ-0-4409-3647.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABZD5V1r90jfejoixi1jJ1EkPvN6SDGZygT418_r3e6h5oFrh5YbwAZLnfyPB-dSX7j72qV7PYnW4vmb9hUwPQJR2AqfnUUk.png?r=805';

export const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhNTY3MDJhODQ4OGE1MGJiYmFiN2ZmMjY5YzY5OTU0MiIsInN1YiI6IjY2MTAwYWVkZTc4ZTJkMDE0YTIxZDQxOSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.6GUuRaCtG6uXug6fh_OYdVSkJTV6PVyIAu3gtrcjB80'
    }
  };

  export const IMG_BASE_URL = 'https://image.tmdb.org/t/p/w200'